import * as handler from './handler';
import { PATH_CREATE_USER, PATH_VERIFY_EMAIL, PATH_LOGIN, PATH_LOGOUT, PATH_FORGOT_PASSWORD, PATH_RESET_PASSWORD, PATH_TOKEN_VALID } from './path';

const createUser = (payload) =>
  handler.post(PATH_CREATE_USER, payload).then((res) => {
    return res;
  });

const verifyEmail = (payload) =>
  handler.get(PATH_VERIFY_EMAIL, payload).then((res) => {
    return res;
  });

const login = (payload) =>
  handler.post(PATH_LOGIN, payload).then((res) => {
    return res;
  });

const logout = () =>
  handler.post(PATH_LOGOUT).then((res) => {
    return res;
  });

const forgotPassword = (payload) =>
  handler.post(PATH_FORGOT_PASSWORD, payload).then((res) => {
    return res;
  });

const resetPassword = (userId, payload) =>
  handler.post(PATH_RESET_PASSWORD + userId, payload).then((res) => {
    return res;
  });

const checkTokenValid = (token) =>
  handler.get(PATH_TOKEN_VALID, { token }).then((res) => {
    return res;
  });

export default { createUser, verifyEmail, login, logout, forgotPassword, resetPassword, checkTokenValid };
